// GENERATED FILE — do not edit; StrapiRoutes registry (one entry per content type)
export const StrapiRoutes = {
  siteSetting: () => "site-setting",
  webPages: () => "web-pages",
  treatments: () => "treatments",
  conditions: () => "conditions",
  teamMembers: () => "team-members",
  questions: () => "questions",
  appointments: () => "appointments",
  messages: () => "messages",
  jobApplications: () => "job-applications",
  posts: () => "posts",
  postCategories: () => "post-categories",
  menuStructs: () => "menu-structs",
  cookieBanner: () => "cookie-banner",
  googleReviews: () => "google-reviews",
};
